import React, { useEffect } from 'react';
import { useStoreon } from 'storeon/react';
import { Events, State } from '@/interfaces';
import { SchedulePanel,Schedule, ScheduleHeader } from './components';

const FlyingList: React.FC = () => {
  const {
    dispatch,
  } = useStoreon<State, Events>();

  useEffect(()=>{
    dispatch('instructors/get')
  },[])
  return (
    <>
      <ScheduleHeader />
      <SchedulePanel />
      <Schedule />
    </>
  );
};  

export default FlyingList;
